import React, { useEffect, useRef, useState } from 'react';
import styles from './DurationModal.module.scss';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ReactComponent as AlarmIcon } from "assets/alarm.svg";

interface DurationModalProps {
  isOpen: boolean;
  onClose: () => void;
  duration: string;
  setDuration: (duration: string) => void;
  setIsDurationModalOpen: (isOpen: boolean) => void;
}

const DurationModal = ({isOpen, onClose,setIsDurationModalOpen, duration, setDuration}: DurationModalProps) => {
  const [selectedDuration, setSelectedDuration] = useState(duration?duration:'15 mins');

  const padList = (list: string[]) => ['', '', ...list, '', ''];
  const durations = padList(Array.from({length: 20}, (_, i) => {
    const minutes = (i + 1) * 15;
    if (minutes < 60) {
      return `${minutes} mins`;
    } else {
      const hours = minutes / 60;
      return `${hours} hours`;
    }
  }));

  const minutesRef = useRef<HTMLDivElement>(null);

  const itemHeight = 40;

  const getCenteredValue = (scrollTop: number, list: string[]) => {
    const index = Math.round(scrollTop / itemHeight);
    return list[index + 2]; // because of padding
  };

  const handleScroll = (ref: React.RefObject<HTMLDivElement>, list: string[], setter: (value: string) => void) => {
    if (ref.current) {
      const top = ref.current.scrollTop;
      const newValue = getCenteredValue(top, list);
      if (newValue !== '') setter(newValue);
    }
  };

  const scrollToValue = (ref: React.RefObject<HTMLDivElement>, value: string, list: string[]) => {
    const index = list.indexOf(value);
    if (index !== -1 && ref.current) {
      ref.current.scrollTop = (index - 2) * itemHeight;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDuration(e.target.value);
  };
  useEffect(() => {
    scrollToValue(minutesRef, selectedDuration, durations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{display: isOpen ? 'block' : 'none'}}>
      <div className={styles.overlay} onClick={onClose} />
        <div className={styles.optsWrapper}>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <div className={styles.headerWrapper}>
              <p style={{fontSize: '18px', fontWeight: '500', textAlign: 'center'}}>Set Meeting Duration</p>
            </div>
            <div className={styles.inputWrapper}>
              <div className={styles.timeWheelsWrapper}>
                <div className={styles.wheelContainer}>
                  <div
                    ref={minutesRef}
                    className={styles.customWheel}
                    onScroll={() => handleScroll(minutesRef, durations, setSelectedDuration)}
                  >
                    {durations.map((m, i) => (
                      <div
                        key={i}
                        className={`${styles.wheelItem} ${m === selectedDuration ? styles.selectedItem : ''}`}
                      >
                        {m}
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className={styles.btnWrapper}>
            <button 
              onClick={() => setIsDurationModalOpen(false)}
              style={{
                background: 'none',
                color: '#E64B37',
                fontSize: '20px',
                borderRadius: '10px',
                border: 'none'
              }}
            >
              <span>CANCEL</span>
            </button>
          </div>
        </div>

        <div className={styles.doneWrapper}>
          <button 
            onClick={() => {
              onClose();
              setDuration(selectedDuration);
            }}
            style={{
              background: 'none',
              color: '#4F7D9C',
              fontSize: '20px',
              margin: '5px',
              borderRadius: '10px',
              border: 'none'
            }}
          >
            Done
          </button>
        </div>
    </div>
  );
};

export default DurationModal; 